<template>
    <div class="tw-flex tw-flex-row tw-gap-4">
        <div class="tw-w-full">
            <div v-html="contents.trainee.body" class="admin-generated tw-text-md"></div>
            <v-row no-gutters>
                <v-col v-for="(document, index) in traineesDocuments" :key="index">
                    <v-sheet class="pa-2 ma-2">
                        <a :href="getDocumentLink(document)" target="_blank">
                            <img :src="getImagePath(document.image_name)" :alt="document.title" />
                        </a>
                    </v-sheet>
                    <div class="text-lg font-light pb-3 text-left">
                        <a :href="getDocumentLink(document)" target="_blank">
                            {{ document.title }}
                        </a>
                    </div>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
    import AppLayoutSidebarNav from "@/Layouts/AppLayoutSidebarNav";


    export default {
        name: "TraineesIndex",

        layout: (h, page) => {
            return h(AppLayoutSidebarNav, [
                page
            ])
        },
        props: {
            'contents': {
                type: Object,
                required: false,
                default: function () {
                    return {}
                }
            },
        },
        data() {
            return {
                traineesDocuments: [],
            }
        },
        mounted() {
            // Fetch trainees documents from the API
            this.fetchTraineesDocuments()
        },
        methods: {
            async fetchTraineesDocuments() {
                try {
                    const response = await axios.get('/trainees-documents')
                    this.traineesDocuments = response.data.traineesDocuments
                } catch (error) {
                    console.error('Error fetching trainees documents:', error)
                }
            },

            getImagePath(image) {
                return `/storage/trainees_documents/${image}`
            },

            getDocumentLink(document) {
                return document.pdf_name ? `/storage/trainees_documents/${document.pdf_name}` : '#'
            }
        },
    }
</script>

<style scoped>

.admin-generated >>> hr {
    margin-top: 15px !important;
    margin-bottom: 15px !important;
    font-family: ABCFavorit !important;
}

</style>
